import { createSlice } from '@reduxjs/toolkit'
import {getSupplierServiceTypes, getSupplierServiceTypesPag} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  supplierServiceTypes: [], 
  supplierServiceTypesPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  }, 
  loading: "idle",
  loadingPag: "idle",
  error: null }

const supplierServiceTypesSlice = createSlice({
  name: 'supplierServiceTypes',
  initialState,
  reducers: {
    clearSupplierServiceTypesError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getSupplierServiceTypes.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getSupplierServiceTypes.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.supplierServiceTypes = action.payload
    },
    [getSupplierServiceTypes.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getSupplierServiceTypesPag.pending]: (state) => {
        state.loading = "loadingPag"; 
        state.error = null
    },
    [getSupplierServiceTypesPag.fulfilled]: (state, action) => {
    state.loadingPag = "succeeded";
    state.supplierServiceTypesPag.elements = action.payload.elements
    state.supplierServiceTypesPag.pageIndex = action.payload.pageIndex;
    state.supplierServiceTypesPag.pageSize = action.payload.pageSize;
    state.supplierServiceTypesPag.totalRecords = action.payload.totalRecords;
    state.supplierServiceTypesPag.totalPages = action.payload.totalPages;
    state.supplierServiceTypesPag.hasPreviousPage = action.payload.hasPreviousPage;
    state.supplierServiceTypesPag.hasNextPage = action.payload.hasNextPage
      
    },
    [getSupplierServiceTypesPag.rejected]: (state, action) => {
        state.loadingPag = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearSuppliersError} = supplierServiceTypesSlice.actions;
export default supplierServiceTypesSlice.reducer
